'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import l from "../defs/Sparkle.es.js";
const o = a.forwardRef((r, a$1) => /* @__PURE__ */ a.createElement(p, { ref: a$1, ...r, weights: l }));
o.displayName = "SparkleIcon";
const s = o;
export {
  s as Sparkle,
  o as SparkleIcon
};
